import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { Text } from "../../../../../../../../../../components/Text";
import { Option } from "../../../../PaymentMethodSection/Option";
import styles from "./styles.pcss";
var OptionComponent = Option;
var EnhancedButton = function EnhancedButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    size: 'm',
    view: "secondary-invert",
    width: props.width,
    "data-t-id": "components-ChangePaymentTypeButton"
  }));
};
var cn = classNames.bind(styles);
export var ChangePaymentTypeButton = function ChangePaymentTypeButton(_ref) {
  var _optionProps$id, _buttonProps$onClick, _optionProps$text$tit;
  var buttonProps = _ref.buttonProps,
    optionProps = _ref.optionProps,
    title = _ref.title;
  var isLoading = !buttonProps || !optionProps;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper')
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: cn('text'),
    color: "secondary",
    isLoading: isLoading,
    variant: "display-extrasmall"
  }, title), /*#__PURE__*/React.createElement(OptionComponent, _extends({}, optionProps, {
    className: cn('option'),
    iconClassName: cn('icon'),
    id: (_optionProps$id = optionProps === null || optionProps === void 0 ? void 0 : optionProps.id) !== null && _optionProps$id !== void 0 ? _optionProps$id : '',
    isLoading: isLoading,
    rightComponentProps: _objectSpread(_objectSpread({}, buttonProps), {}, {
      onClick: (_buttonProps$onClick = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) !== null && _buttonProps$onClick !== void 0 ? _buttonProps$onClick : function () {},
      Component: EnhancedButton
    }),
    text: _objectSpread(_objectSpread({}, optionProps === null || optionProps === void 0 ? void 0 : optionProps.text), {}, {
      title: (_optionProps$text$tit = optionProps === null || optionProps === void 0 ? void 0 : optionProps.text.title) !== null && _optionProps$text$tit !== void 0 ? _optionProps$text$tit : ''
    })
  })));
};